interface CountProps {
  value: number
  one: string
  many: string
}

// The figure is the fact and the word only names it, so the figure is the darker of the two.
export const Count = ({ value, one, many }: CountProps) => (
  <span className="text-ink-subtle">
    <span className="font-medium tabular-nums text-foreground">
      {value.toLocaleString()}
    </span>{' '}
    {value === 1 ? one : many}
  </span>
)
